import React, { useState, useContext, createContext, ReactNode } from 'react';
import { authService } from '../services/authService';

interface AuthContextType {
  user: string | null;
  access: string | null;
  refresh: string | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }): React.ReactElement => {
  const [user, setUser] = useState<string | null>(localStorage.getItem('user'));
  const [access, setAccess] = useState<string | null>(localStorage.getItem('access'));
  const [refresh, setRefresh] = useState<string | null>(localStorage.getItem('refresh'));

  const login = async (email: string, password: string) => {
    const { access, refresh } = await authService.login(email, password);
    setUser(email);
    setAccess(access);
    setRefresh(refresh);
    localStorage.setItem('user', email);
    localStorage.setItem('access', access);
    localStorage.setItem('refresh', refresh);
  };

  const logout = () => {
    setUser(null);
    setAccess(null);
    setRefresh(null);
    localStorage.removeItem('user');
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
  };

  return (
    <AuthContext.Provider value={{ user, access, refresh, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
} 